import { Injectable } from '@angular/core';

@Injectable()
export class PxDownloadLinkConfigService {
    /** Hostname of your API */
    apiHost?: string;
    /** Cookie expire time in second */
    cookieExpireTimeInSeconds: number;
    /** Key of Token */
    tokenKey: string;
}
